export const SELECT_PLAN = "SELECT_PLAN"
export const HOME_PLANS = "HOME_PLANS"
export const BUSINESS_PLANS = "BUSINESS_PLANS"
export const FTTX_HOME_PAGE_HEADER = "FTTX_HOME_PAGE_HEADER"
export const FTTX_HOME_PAGE_DESCRIPTION = "FTTX_HOME_PAGE_DESCRIPTION"
export const MIFI_PLANS_SUBHEADING="MIFI_PLANS_SUBHEADING"
export const MIFI_PLANS_HEADING = "MIFI_PLANS_HEADING"
export const MIFI_PLANS_PAGE= "MIFI_PLANS_PAGE"
export const PLANS_NOT_AVAILABLE_INFO="PLANS_NOT_AVAILABLE_INFO"
export const LEAD_GENERATION_FORM_HEADING = "LEAD_GENERATION_FORM_HEADING"
export const LEAD_GENERATION_FORM_DES = "LEAD_GENERATION_FORM_DES"
export const RED_TEXT='red'

export const ENDPOINTS = {
    MIFI_PLANS_URL: '/product/v1/bundle',
    SUBMIT_LEAD_URL: "/form/v2/save",

}